import { useCallback, useState } from 'react';

import usePlansReactivation from '../../queries/usePlansReactivation.query';
import { usePlanReactivationModalStore } from '../../stores';
import { ReactivationSteps } from '../../types';

export const useSinglePlanReactivationModal = () => {
  const [loading, setLoading] = useState(false);
  const [isServerError, setIsServerError] = useState(false);
  
  const planId = usePlanReactivationModalStore((state) => state.planId);
  const planName = usePlanReactivationModalStore((state) => state.planName);
  const handleSetStep = usePlanReactivationModalStore((state) => state.handleSetStep);
  
  const reactivatePlans = usePlansReactivation();

  const onConfirm = useCallback(async () => {
    setLoading(true);
    try {
      await reactivatePlans({ planIds: [planId as string] });
      
      handleSetStep(ReactivationSteps.RESUME);
    } catch {
      setIsServerError(true);
    } finally {
      setLoading(false);
    }
  }, [planId, handleSetStep, reactivatePlans]);

  return {
    planName,
    loading,
    isServerError,
    setIsServerError,
    onConfirm,
  };
};
